var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTableNoResults(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1068,
    height: 900,
    viewBox: "0 0 1068 900",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "No Results"
  }, /*#__PURE__*/React.createElement("g", {
    id: "circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Stroke 1",
    d: "M35.8462 413.208V422.534",
    stroke: "#D2D8DF",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Stroke 2",
    d: "M14.9121 418.261L22.5274 426.105",
    stroke: "#D2D8DF",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 4",
    d: "M6 439.139H16.768",
    stroke: "#D2D8DF",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 6",
    d: "M14.042 460.394L21.6573 452.55",
    stroke: "#D2D8DF",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 9",
    d: "M35.8506 462.944V453.618",
    stroke: "#D2D8DF",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 10",
    d: "M51.3756 456.725L45.1626 450.508",
    stroke: "#D2D8DF",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 11",
    d: "M63.797 441.183H54.4775",
    stroke: "#D2D8DF",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 12",
    d: "M57.5953 419.425L51.3823 425.642",
    stroke: "#D2D8DF",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 13",
    d: "M520.989 6V12.2169",
    stroke: "#D2D8DF",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 15",
    d: "M502.349 24.6508H508.562",
    stroke: "#D2D8DF",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 16",
    d: "M520.985 43.3005V37.0836",
    stroke: "#D2D8DF",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 17",
    d: "M536.523 24.6508H530.31",
    stroke: "#D2D8DF",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 18",
    d: "M169.641 267.111V276.436",
    stroke: "#D2D8DF",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 19",
    d: "M141.68 295.087H150.999",
    stroke: "#D2D8DF",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 20",
    d: "M169.632 319.953V310.627",
    stroke: "#D2D8DF",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 21",
    d: "M194.492 295.089H185.172",
    stroke: "#D2D8DF",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Stroke 22",
    d: "M820.325 606.053C827.749 606.053 833.77 612.08 833.77 619.51C833.77 626.943 827.749 632.967 820.325 632.967C812.901 632.967 806.88 626.943 806.88 619.51",
    stroke: "#D2D8DF",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 26",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M878.849 483.965C886.832 481.473 899.069 471.704 901.902 461.193C904.47 470.484 915.238 481.473 924.954 482.305C914.017 486.18 903.56 497.691 901.902 506.735C900.773 497.517 886.31 485.309 878.849 483.965Z",
    fill: "#EBECEE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 28",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.3921 601.904C84.3849 600.658 90.5008 595.775 91.917 590.519C93.2014 595.162 98.584 600.658 103.442 601.075C97.9748 603.01 92.7477 608.767 91.917 613.289C91.3526 608.68 84.1212 602.574 80.3921 601.904Z",
    fill: "#EBECEE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 30",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M154.489 169.492C154.489 175.257 149.822 179.927 144.064 179.927C138.305 179.927 133.639 175.257 133.639 169.492C133.639 163.73 138.305 159.058 144.064 159.058C149.822 159.058 154.489 163.73 154.489 169.492Z",
    fill: "#D1D8DF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 32",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M832.638 197.511C832.638 207.143 824.834 214.951 815.213 214.951C805.587 214.951 797.786 207.143 797.786 197.511C797.786 187.879 805.587 180.071 815.213 180.071C824.834 180.071 832.638 187.879 832.638 197.511Z",
    fill: "#EBECEE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 34",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1068 150.261C1068 157.903 1061.81 164.095 1054.18 164.095C1046.54 164.095 1040.36 157.903 1040.36 150.261C1040.36 142.619 1046.54 136.427 1054.18 136.427C1061.81 136.427 1068 142.619 1068 150.261Z",
    fill: "#EBECEE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 36",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M346.327 796.378C346.327 801.196 342.427 805.1 337.614 805.1C332.803 805.1 328.903 801.196 328.903 796.378C328.903 791.561 332.803 787.657 337.614 787.657C342.427 787.657 346.327 791.561 346.327 796.378Z",
    stroke: "#D2D8DF",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 38",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M341.144 102.458C341.144 108.223 336.476 112.892 330.719 112.892C324.962 112.892 320.294 108.223 320.294 102.458C320.294 96.6957 324.962 92.0235 330.719 92.0235C336.476 92.0235 341.144 96.6957 341.144 102.458Z",
    stroke: "#D2D8DF",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 40",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M601.072 892.953C594.41 895.49 586.955 892.14 584.42 885.475C581.886 878.808 585.23 871.343 591.894 868.809C598.554 866.272 606.009 869.619 608.544 876.287C611.081 882.954 607.734 890.417 601.072 892.953Z",
    stroke: "#D2D8DF",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "search"
  }, /*#__PURE__*/React.createElement("g", {
    id: "documents"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill 1",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M603.095 646.345H348.348C330.418 646.345 315.741 631.615 315.741 613.613L315.741 250.102C315.741 232.1 330.418 217.378 348.348 217.378L603.095 217.378C621.033 217.378 635.709 232.1 635.709 250.102L635.709 613.613C635.709 631.615 621.033 646.345 603.095 646.345Z",
    fill: "#E0E2EE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M581.351 661.888H326.604C308.674 661.888 293.997 647.158 293.997 629.156L293.997 265.645C293.997 247.643 308.674 232.921 326.604 232.921L581.351 232.921C599.288 232.921 613.965 247.643 613.965 265.645L613.965 629.156C613.965 647.158 599.288 661.888 581.351 661.888Z",
    fill: "#E8EBF2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M560.196 674.156H304.923C286.956 674.156 272.249 659.487 272.249 641.56L272.249 279.554C272.249 261.626 286.956 246.965 304.923 246.965L560.196 246.965C578.171 246.965 592.878 261.626 592.878 279.554L592.878 641.56C592.878 659.487 578.171 674.156 560.196 674.156Z",
    fill: "#D8DBEA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 8",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M560.196 674.156H304.923C286.956 674.156 272.249 659.487 272.249 641.56L272.249 279.554C272.249 261.626 286.956 246.965 304.923 246.965L560.196 246.965C578.171 246.965 592.878 261.626 592.878 279.554L592.878 641.56C592.878 659.487 578.171 674.156 560.196 674.156Z",
    fill: "#F1F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 11",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M523.403 357.258H334.853C329.468 357.258 325.061 353.062 325.061 347.936C325.061 342.803 329.468 338.608 334.853 338.608H523.403C528.788 338.608 533.195 342.803 533.195 347.936C533.195 353.062 528.788 357.258 523.403 357.258Z",
    fill: "#E0E2EE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 13",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M523.403 413.209H334.853C329.468 413.209 325.061 409.013 325.061 403.887C325.061 398.754 329.468 394.558 334.853 394.558H523.403C528.788 394.558 533.195 398.754 533.195 403.887C533.195 409.013 528.788 413.209 523.403 413.209Z",
    fill: "#E0E2EE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 15",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M523.4 469.161H334.85C329.465 469.161 325.058 464.965 325.058 459.839C325.058 454.713 329.465 450.51 334.85 450.51H523.4C528.785 450.51 533.192 454.713 533.192 459.839C533.192 464.965 528.785 469.161 523.4 469.161Z",
    fill: "#E0E2EE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 17",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M523.403 525.115H334.853C329.468 525.115 325.061 520.919 325.061 515.793C325.061 510.66 329.468 506.464 334.853 506.464H523.403C528.788 506.464 533.195 510.66 533.195 515.793C533.195 520.919 528.788 525.115 523.403 525.115Z",
    fill: "#E0E2EE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 19",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M433.273 581.066H334.895C329.487 581.066 325.061 576.87 325.061 571.744C325.061 566.611 329.487 562.415 334.895 562.415H433.273C438.681 562.415 443.107 566.611 443.107 571.744C443.107 576.87 438.681 581.066 433.273 581.066Z",
    fill: "#E0E2EE"
  })), /*#__PURE__*/React.createElement("g", {
    id: "search_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill 21",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M628.831 508.752C591.129 546.472 532.761 550.727 490.386 521.605C484.97 517.816 479.816 513.561 475.009 508.752C472.535 506.284 470.202 503.737 468.005 501.056C463.609 495.701 459.759 489.991 456.604 484.09C451.047 474.124 447.268 463.55 445.204 452.619C438.548 418.339 448.501 381.442 475.009 354.93C501.58 328.338 538.461 318.444 572.724 325.04C583.642 327.168 594.22 330.948 604.181 336.445C610.087 339.672 615.716 343.524 621.076 347.922C623.748 350.113 626.293 352.454 628.76 354.93C633.575 359.739 637.891 364.888 641.607 370.313C670.724 412.7 666.463 471.103 628.831 508.752Z",
    fill: "white",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 23",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M618.289 501.325C579.065 540.582 515.499 540.574 476.267 501.325C437.087 462.12 437.087 398.506 476.318 359.257C515.499 320.051 579.065 320.051 618.246 359.257C657.47 398.506 657.47 462.12 618.289 501.325ZM638.415 339.089C588.067 288.709 506.48 288.709 456.132 339.089C405.792 389.461 405.748 471.152 456.089 521.531C501.911 567.368 573.732 571.502 624.248 533.867C629.182 530.186 633.934 526.06 638.466 521.531C642.992 516.996 647.116 512.241 650.787 507.304C688.398 456.749 684.231 384.933 638.415 339.089Z",
    fill: "#E0E2EE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 25",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M827.56 711.441L825.446 713.556C811.462 727.556 788.563 727.556 774.572 713.556L645.451 584.353L698.44 531.331L827.56 660.534C841.551 674.534 841.551 697.44 827.56 711.441Z",
    fill: "url(#paint0_linear_777_5946)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 27",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M644.571 503.355L682.726 541.535L655.638 568.633L617.49 530.453C622.525 526.697 627.366 522.486 631.999 517.866C636.616 513.245 640.825 508.393 644.571 503.355Z",
    fill: "#E0E2EE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 29",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M822.621 658.943L769.97 711.62L760.491 702.128L813.135 649.451L822.621 658.943Z",
    fill: "#01A1B7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 31",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M701.36 533.154L647.267 587.282L639.23 579.241L693.323 525.113L701.36 533.154Z",
    fill: "url(#paint1_linear_777_5946)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 33",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M592.317 345.75L459.659 478.485C454.663 469.526 451.266 460.019 449.418 450.192L564.04 335.496C573.854 337.416 583.363 340.808 592.317 345.75Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 35",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M632.808 377.3L489.39 512.679C484.254 509.295 479.366 505.488 474.807 501.184C472.46 498.969 470.241 496.697 468.164 494.297L613.329 357.256C615.87 359.223 618.285 361.318 620.624 363.534C625.183 367.837 629.284 372.445 632.808 377.3Z",
    fill: "white",
    fillOpacity: 0.5
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_777_5946",
    x1: 741.752,
    y1: 434.969,
    x2: 549.028,
    y2: 627.571,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01A1B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4DE9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_777_5946",
    x1: 670.295,
    y1: 494.028,
    x2: 608.126,
    y2: 556.158,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01A1B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#27CDE3"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableNoResults);
export default __webpack_public_path__ + "static/media/table-no-results.e85237e7efc64de86805493f5d9572e9.svg";
export { ForwardRef as ReactComponent };